/**
 * Matchmaker query hook (F11).
 *
 * Disabled until a startup is chosen, so the page can mount without one and
 * fire no request — the endpoint requires a startup id.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.18
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { MatchmakerQuery, MatchmakerResult } from '@nexus/contracts';

import { queryKeys } from '../../../lib/query-keys';

import * as matchmakerApi from './matchmaker.api';

export function useMatchmaker(
  query: MatchmakerQuery | null,
): UseQueryResult<MatchmakerResult> {
  /* A concrete value the queryFn can close over without a non-null assertion:
     when `query` is null the fallback is never used, because `enabled` is
     false. */
  const effective: MatchmakerQuery = query ?? { startupId: '' };

  return useQuery({
    queryKey: queryKeys.matchmaker.forStartup(query ?? {}),
    queryFn: () => matchmakerApi.matchStartupToAssets(effective),
    enabled: query !== null,
  });
}
